import { render, staticRenderFns } from "./LegalEntityMonitoringEvents.vue?vue&type=template&id=098ec9d5&scoped=true"
import script from "./LegalEntityMonitoringEvents.vue?vue&type=script&lang=js"
export * from "./LegalEntityMonitoringEvents.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityMonitoringEvents.vue?vue&type=style&index=0&id=098ec9d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ec9d5",
  null
  
)

export default component.exports